'use strict';

var CssBaseline = require('../node_modules/@material-ui/core/esm/CssBaseline/CssBaseline.js');



module.exports = CssBaseline["default"];
